import PropTypes from "prop-types";
import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useLocation } from "react-router-dom";

import { Button, CircularProgress } from "@material-ui/core";

import { FleetContext, RiderContext } from "../../../context";
import { useDialog } from "../../../hooks/useDialog";

const ReservationTableButton = ({
  reservation,
  riderId,
  endReservation,
  handleFetchReservationsWithLoading,
  handleFetchReservations,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { fetchTrips } = useContext(FleetContext);
  const { reservations } = useContext(RiderContext);
  const [resInProgress, setResInProgress] = useState(false);
  const [waitingForTripToEnd, setWaitingForTripToEnd] = useState(false);

  useEffect(() => {
    setWaitingForTripToEnd(reservation.stop && !reservation.trip?.stop && reservation.trip);
    setResInProgress(reservation.start && !reservation.stop);
  }, [reservations, reservation.stop, reservation.trip?.stop]);

  const [endReservationDialog, reservationDialog] = useDialog({
    title: t("Riders.Reservations.Dialogs.EndReservationTitle"),
    body: t("Riders.Reservations.Dialogs.EndReservationBody"),
  });

  useEffect(() => {
    if (waitingForTripToEnd) setInterval(handleFetchReservations, 5000);
    else clearInterval();

    return () => clearInterval();
  }, [waitingForTripToEnd]);

  if (resInProgress)
    return (
      <>
        <Button
          onClick={() =>
            endReservationDialog(() => async () => {
              await endReservation(reservation.id);
              fetchTrips([reservation.trip?.id]);
              handleFetchReservationsWithLoading();
            })
          }
        >
          {t("Riders.Reservations.Buttons.EndReservation")}
        </Button>
        {reservationDialog}
      </>
    );

  if (reservation.stop && reservation.trip?.stop && !reservation.group_reservation) {
    return (
      <Button
        component={RouterLink}
        to={{
          pathname: `/riders/${riderId}/reservations/${reservation.id}/credit-wallet`,
          state: { background: location },
        }}
      >
        {t("Riders.Reservations.Buttons.Credit")}
      </Button>
    );
  }

  if (waitingForTripToEnd) {
    return (
      <Button>
        <CircularProgress size={20} color="inherit" />
      </Button>
    );
  }

  if (!reservation.group_reservation) {
    return <Button disabled>{t("Riders.Reservations.Buttons.Rebill")}</Button>;
  }

  return <></>;
};

ReservationTableButton.propTypes = {
  reservation: PropTypes.shape({
    id: PropTypes.string,
    vehicleId: PropTypes.string,
    start: PropTypes.any,
    stop: PropTypes.any,
    trip: PropTypes.object,
    group_reservation: PropTypes.any,
  }).isRequired,
  riderId: PropTypes.string.isRequired,
  endReservation: PropTypes.func.isRequired,
  handleFetchReservationsWithLoading: PropTypes.func.isRequired,
  handleFetchReservations: PropTypes.func.isRequired,
};

export default ReservationTableButton;
